import {IExternalLinksHandlersFactory} from "./external-links-handlers-factory.interface";
import {IRegistrationExternalLinkHandler} from "../handlers/registration/registration.external-link-handler.interface";
import {RegistrationExternalLinkHandler} from "../handlers/registration/registration.external-link-handler";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMyAccountExternalLinkHandler} from "../handlers/my-account/my-account.external-link-handler.interface";
import {MyAccountExternalLinkHandler} from "../handlers/my-account/my-account.external-link-handler";
import {ICashierExternalLinkHandler} from "../handlers/cashier/cashier.external-link-handler.interface";
import {CashierExternalLinkHandler} from "../handlers/cashier/cashier.external-link-handler";
import {IOmgExternalLinkHandler} from "../handlers/omg/omg.external-link-handler.interface";
import {OmgExternalLinkHandler} from "../handlers/omg/omg.external-link-handler";


export class ExternalLinksHandlersFactory implements IExternalLinksHandlersFactory {
    constructor(protected readonly services: IServiceFactoryExtended) {

    }
    get registration(): IRegistrationExternalLinkHandler {
        return new RegistrationExternalLinkHandler(this.services);
    }

    get myAccount(): IMyAccountExternalLinkHandler {
        return new MyAccountExternalLinkHandler(this.services);
    }

    get cashier(): ICashierExternalLinkHandler {
        return new CashierExternalLinkHandler(this.services);
    }

    get omg(): IOmgExternalLinkHandler {
        return new OmgExternalLinkHandler(this.services);
    }

}